import { Form, Upload, theme } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

const { Dragger } = Upload;

const getExtensionsFromAccept = (accept) => accept.split(',').map((extension) => extension.trim());

const getHintFromAccept = (accept) => {
  const extensions = getExtensionsFromAccept(accept);

  if (extensions.length === 1) {
    return `Solo se permiten archivos con extensión ${extensions[0]}`;
  }

  return `Solo se permiten archivos con las siguientes extensiones: ${extensions.join(', ')}`;
};

const getRequiredMessageFromAccept = (accept) => {
  const extensions = getExtensionsFromAccept(accept);

  if (extensions.length === 1) {
    return `Debe seleccionar un archivo ${extensions[0]}`;
  }

  return `Debe seleccionar un archivo con alguna de las siguientes extensiones: ${extensions.join(', ')}`;
};

const UPLOAD_TEXT = 'Haga clic o arrastre el archivo aquí';

export const CertificateUploadField = ({ name, label, accept }) => {
  const { token: themeToken } = theme.useToken();

  return (
    <Form.Item
      name={name}
      label={label}
      valuePropName='fileList'
      getValueFromEvent={e => e?.fileList} // Extrae el array de archivos desde el evento de carga del Dragger que se pasa al form
      rules={[{ required: true, message: getRequiredMessageFromAccept(accept) }]}
    >
      <Dragger
        maxCount={1}
        accept={accept}
        beforeUpload={() => false} // Impide el upload automático
      >
        <p className='ant-upload-drag-icon'>
          <FontAwesomeIcon icon={faUpload} color={themeToken.colorPrimary} size='2xl' />
        </p>
        <p className='ant-upload-text'>{UPLOAD_TEXT}</p>
        <p className='ant-upload-hint'>{getHintFromAccept(accept)}</p>
      </Dragger>
    </Form.Item>
  );
};
